import Emitter from './emitter'

import { times, isFinite, isString, isObject, defaultTo } from 'lodash-es'

let id = 0
const nextId = () => id++

export default function Pull(...args) {
  const size = defaultTo(args.find(isFinite), 0)
  const name = defaultTo(args.find(isString), null)

  const pull = []

  pull.id = nextId()
  pull.size = size
  pull.name = name
  // release
  pull.release = release
  pull.releaseAll = releaseAll
  pull.releaseByData = releaseByData
  pull.releaseByElm = releaseByElm
  // request
  pull.requestByIndex = requestByIndex
  pull.requestElm = requestElm
  pull.request = request
  // debug
  pull.usedCount = usedCount
  pull.idleCount = idleCount
  pull.state = state
  // main
  times(size, createElm)
  // export
  return pull

  // createElm
  function createElm() {
    const index = pull.length
    const sign = defaultTo(pull.name, `pull[id=${pull.id}]`) + `::elm[uid=${index}]`
    const newElm = {
      index,
      count: 0,
      used: false,
      data: null,
      emitter: Emitter(sign)
    }
    pull.push(newElm)
    return newElm
  }

  // release
  function release(dataSet) {
    dataSet.forEach(releaseByData)
    return pull
  }

  function releaseAll() {
    pull.filter(isElmUsed).forEach(releaseByElm)
    return pull
  }

  function releaseByData(data) {
    const elm = pull.find((elm) => elm.data === data)
    return releaseByElm(elm)
  }

  function releaseByElm(elm) {
    elm.data = null
    elm.used = false
    elm.count++
    elm.emitter.emit()
    return pull
  }

  // request
  function request(dataSet) {
    return dataSet.map(requestElm)
  }

  function requestElm(data) {
    const elm = pull.find(isElmIdle)
    if (!isObject(elm)) {
      const newElm = createElm()
      newElm.count++
      newElm.data = data
      newElm.used = true
      return newElm
    } else {
      elm.count++
      elm.data = data
      elm.used = true
      elm.emitter.emit()
      return elm
    }
  }

  function requestByIndex(index, data) {
    const elm = pull[index]

    elm.count++
    elm.data = data
    elm.used = true
    elm.emitter.emit()

    return elm
  }

  // debug
  function usedCount() {
    return pull.filter(isElmUsed).length
  }

  function idleCount() {
    return pull.filter(isElmIdle).length
  }

  function state() {
    return pull.map(elmState)
  }

  // helpers
  function isElmUsed(elm) {
    return elm.used === true
  }

  function isElmIdle(elm) {
    return elm.used === false
  }

  function elmState(elm) {
    return {
      used: elm.used,
      index: elm.index,
      count: elm.count
    }
  }
}
